// extracted by mini-css-extract-plugin
module.exports = {"body":"ImageShowShop_body__3COQf"};